var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "select",
    {
      staticClass: "twzipcode twzipcode__county",
      attrs: { id: _vm.id, name: _vm.name },
      domProps: { value: _vm.value },
      on: {
        change: function($event) {
          return _vm.$emit("input", $event.target.value)
        }
      }
    },
    _vm._l(_vm.counties, function(county, i) {
      return _c(
        "option",
        { key: "option-" + i, domProps: { value: county.value } },
        [_vm._v(_vm._s(county.text))]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }